import { render, staticRenderFns } from "./solid_buckle.vue?vue&type=template&id=002231f6"
import script from "./solid_buckle.vue?vue&type=script&lang=js"
export * from "./solid_buckle.vue?vue&type=script&lang=js"
import style0 from "./solid_buckle.vue?vue&type=style&index=0&id=002231f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports